import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './store/mutations';
import actions from './store/actions';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        is_loading: true,
        now_no_select_result:'',
        error_message:'',
        atomaku_error_message:'',
        xlsx_data : {},
        xlsx_select_data : {},
        search_data :{},
        search_atomaku_data : {},
        step1_data : {
            item_number : '',
            atomaku_number : ''
        },
        step2_data:{
            style_selected1_id : '',
            style_selected1_name : '',
            style_selected2_id : '',
            style_selected2_name : '',
        },
        step3_data:{
            width_size : 200,
            height_size : 200,
            size_min_max: '',
            id_size : '',
            add_size_min_max : '',
            add_wid_max : '',
            add_hid_max : '',
            hida : '',
            ura : '',
            open : '',
            suso : '',
            mecha : '',
            kurumi : '',
            cloth : '',
            fringe : '',
            deco_fringe:'',
            trim:'',
            wid : '',
            hid : '',
            select_size:'',
            atomaku_style:'',
            is_sw:'',
            finish_size:'',
            quilting_type:'',
            bed_size:'',
            return_type:'',
            window_number:'',
        },
        step4_data:{
            set_number  : 1,
        },
        step5_data:{
            room_selected  : '',
            other_selected : ''
        },
        price_data:{
            price:0,
            price_ura:0,
            total_price:0,
            price_csv:'',
            price_ura_csv:'',
            price_file:'',
            price_load_data:'',
            price_ura_file:'',
            price_load_ura_data:'',
            check_file:'',
            price_item_number:'',
            price_add_file:'',
            price_load_add_data:'',
            price_add_csv:'',
            price_add:0,
            price_atomaku_number:'',
            check_atomaku_file:'',
            price_atomaku_file:'',
            price_atomaku_csv:'',
            price_atomaku:0,
            price_error:'',
            total_price:'',
        },
    },
    mutations,
    actions
})
